import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../tools/storage.service';
import { IxellAPIService, Roles } from '../../tools/api.service';
import { ActivationLight } from '../../models/activationlight';
import { HeaderService } from '../../tools/header.service';
import { ErrorService } from '../../tools/error.service';
import { Sort } from '@angular/material/sort';
import { Utils } from 'src/app/tools/utils';

@Component({
  selector: 'app-activationlist',
  templateUrl: './activationlist.component.html',
  styleUrls: ['./activationlist.component.scss']
})
export class ActivationlistComponent implements OnInit, OnDestroy {
  // Sub 
  activationsSub: any;
  activationInfoSub: any;
  // Objets
  activationLight: ActivationLight[] = [];
  allActivation: ActivationLight[] = [];
  activationLst: ActivationLight[] = [];
  dataInfo: any[] = [];
  actualId: any;
  displayedColumns = ["status", "codebalance", "compagnieutilisateur", "activdate", "activcode", "activdatestart", "activdateend", "info"];
  constructor(private storage: StorageService, private api: IxellAPIService, private headerService: HeaderService, private errorService: ErrorService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    // Vérification si l'utilisateur est ctc
    if (Number.parseInt(this.storage.get("role")) & Roles.CTC) {
      this.activationsSub = this.api.ctcActivation().subscribe(data => {
        // Ajoute toutes les activations au tableau
        data.forEach(element => {
          if (element.licenceStart != null)
            element.licenceStart = element.licenceStart.split(' ')[0];
          if (element.licenceEnd != null)
            element.licenceEnd = element.licenceEnd.split(' ')[0];
          this.allActivation.push(ActivationLight.parseToActivationLight(element));
          this.activationLst = this.allActivation.slice();
        })
      }, error => {
        if (this.activationsSub != null) this.activationsSub.unsubscribe();
        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "ctcActivation", new Date().toString());
        console.log(error);
      });
      // Flèche de retour navbar
      this.headerService.changeCanBack(true);
      this.headerService.changeTitle("IxellWebLab");
      this.headerService.changeLogo(null);
    }
  }

  ngOnDestroy() {
    if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
    if (this.activationsSub != null) this.activationsSub.unsubscribe();
  }

  displayInfoActivation(id: any) {
    // Récupère l'id en string, la passe en int
    this.actualId = id;
    var idInt = parseInt(id, 10);
    this.activationInfoSub = this.api.infoActivation(idInt , 0).subscribe(data => {
      // Ajoute l'activation dans le tableau, affiche la modal
      this.dataInfo = [];
      this.dataInfo.push(data[0]);
      let modal = document.getElementById("modalInfo");
      modal.style.display = "block";
    }, error => {
      if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
      console.log(error);
    })
  }

  closeModal() {
    // Ferme la modal
    let modal = document.getElementById("modalInfo");
    modal.style.display = "none";
  }

  sortScale(sort: Sort, status: string) {
    var data = this.activationLst;
    if (!sort.active || sort.direction === '') 
      return;
    data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'codebalance':
          return compare(parseInt(a.scaleCode), parseInt(b.scaleCode), isAsc);
        case 'activdate':
          return compareDate(a.activationDate, b.activationDate, isAsc);
        case 'compagnieutilisateur':
          return compare(a.companySocialReason, b.companySocialReason, isAsc);
        case 'activcode':
          return compare(a.activationCode, b.activationCode, isAsc);
        case 'activdatestart':
          return compareDate(a.licenceStart, b.licenceStart, isAsc);
        case 'activdateend':
          return compareDate(a.licenceEnd, b.licenceEnd, isAsc);
        default: return 0;
      } 
    });
    this.activationLst = data.slice();
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  if (a == null) return -1;
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function compareDate(a: string, b: string, isAsc: boolean) {
  if (a == null) return -1;
  var tmpa = a.split("/");
  var tmpb = b.split("/");
  a = tmpa[1] + "/" + tmpa[0] + "/" + tmpa[2];
  b = tmpb[1] + "/" + tmpb[0] + "/" + tmpb[2];
  return (new Date(a) < new Date(b) ? -1 : 1) * (isAsc ? 1 : -1);
}
